import { render, staticRenderFns } from "./editar-observado.vue?vue&type=template&id=218a4bcc"
import script from "./editar-observado.vue?vue&type=script&lang=js"
export * from "./editar-observado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports